'use es6';

import { Loadable } from 'foundations-components/transitional/utils/Loadable';
const loader = () => import( /* webpackChunkName: "save-report-dialog" */'./SaveReportDialogContainer');
export default Loadable({
  loader,
  LoadingComponent: () => null
});